<ion-spinner class="spinner"></ion-spinner>
<img class="inner-img" [src]="_src" [alt]="_alt" (load)="_imageLoaded()"/>
<ng-content *ngIf="_display === 'cover'"></ng-content>
